export default __webpack_public_path__ + "static/media/PROJECT 2.473ae0fa.png";